module.exports = new __parcel__URL__("svt_logo_etusivu_saatekirje_print.e496342f.jpg").toString();